import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";
import { KYCComplaince } from "../@types";

function useSaveBank<T>(
  options?: MutationOptions<APIResponse<T>, APIError, KYCComplaince>
) {
  const queryClient = useQueryClient();
  const { isLoading, isError, mutate, error } = useMutation<
    APIResponse<T>,
    APIError,
    KYCComplaince
  >(
    async (variables: Record<any, any>) => {
      return post(API_URL + "/account/user/account/save-bank", variables, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    {
      onSettled() {
        queryClient.invalidateQueries("profile");
      },
      ...options,
    }
  );

  return {
    saveBank: mutate,
    isSaveBankError: isError,
    saveBankError: error,
    isSavingBank: isLoading,
  };
}

export default useSaveBank;
